<!-- <div class="input-group">
    <input  id="{{ 'disabled' + fieldKey }}" type="text"
        class="form-control has-value color-light-grey-disabledType"
        [formControl]="formControl" [formlyAttributes]="field">
    <label for="DisabledInputField">{{field.templateOptions.label}} </label>
</div> -->

<div class="input-group">
    @if(field.props?.twoDecimalOnly){<ds-textbox twoDigitDecimalNumber
        [formControl]="formControl"
        [formlyAttributes]="field"
        [textboxInput]="textboxConfig"
        (valueChange) = "OnValueChange($event)"
    ></ds-textbox>}
    @else if(field.props?.intizerOnly){<ds-textbox intizerOnly
        [formControl]="formControl"
        [formlyAttributes]="field"
        [textboxInput]="textboxConfig"
        (valueChange) = "OnValueChange($event)"
    ></ds-textbox>}
    @else if(field.props?.sixDigitAfterAndBeforeDecimalNumber){<ds-textbox sixDigitAfterAndBeforeDecimalNumber
        [formControl]="formControl"
        [formlyAttributes]="field"
        [textboxInput]="textboxConfig"
        (valueChange) = "OnValueChange($event)"
    ></ds-textbox>}
    @else{<ds-textbox
        [formControl]="formControl"
        [formlyAttributes]="field"
        [textboxInput]="textboxConfig"
        (valueChange) = "OnValueChange($event)"
    ></ds-textbox>}
</div>